import React from 'react';

import { useInitializedFlags } from '@liscio/common';
import { GlobalLoader, ResponsiveView } from '@liscio/ui';

import LoginV5Desktop from './LoginV5View/LoginV5Desktop/LoginV5Desktop';
import LoginV5Mobile from './LoginV5View/LoginV5Mobile/LoginV5Mobile';
import LoginView from './LoginView/LoginView';
import { useFirmViewMode } from 'custom-hooks/useFirmViewMode';

export const LoginFlaggedView = () => {
  const { isMobile } = useFirmViewMode();
  const {
    isInitialized,
    flags: { v5Login },
  } = useInitializedFlags();

  if (!isInitialized) {
    return <GlobalLoader open />;
  }

  if (v5Login) {
    return (
      <ResponsiveView
        SmallView={<LoginV5Mobile />}
        LargeView={isMobile ? <LoginV5Mobile /> : <LoginV5Desktop />}
      />
    );
  }

  return <LoginView />;
};

export default LoginFlaggedView;
